import { apiWrapper } from "apis/CommonApi";
import Pagenation from "components/Pagenation";
import { act, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { getFireReceiverStatusName, FireReceiverStatus, getFireReceiverSearchTypeName, FireReceiverSearchType, FireReceiverStatusChoice, getFireReceiverStatusChoiceName } from "utils/common";
import { getDateTime } from "utils/date";

//화재수신기 관리
export default function FireReceiverManagementComponent() {
  const itemsPerPage = 100;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSearchListOpen, setIsSearchListOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("0");
  const [selectedSearchType, setSelectedSearchType] = useState("0");
  const [searchText, setSearchText] = useState("");
  const [validBeginDate, setValidBeginDate] = useState('');
  const [validEndDate, setValidEndDate] = useState('');
  const [suspendBeginDate, setSuspendBeginDate] = useState('');
  const [suspendEndDate, setSuspendEndDate] = useState('');
  const [selectedNewStatus, setSelectedNewStatus] = useState("0");
  const [isStatusListOpen, setIsStatusListOpen] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [checkedIds, setCheckedIds] = useState([]);

  useEffect(() => {
    getData(1);
  }, [selectedStatus]);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      result = await dbmsApi.getFireReceiverManageList(
        selectedStatus,
        selectedSearchType,
        searchText,
        page,
        itemsPerPage
      );

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleTabClick = (status) => {
    setSelectedStatus(status);
  };

  const handleItemClick = (e, id) => {
    if (!e.target.closest('.serial-number_item')) {
      e.currentTarget.classList.toggle('active');

      if (e.currentTarget.classList.contains('active')) {
        setCheckedIds([...checkedIds, id]);
      } else {
        setCheckedIds(checkedIds.filter((a) => a !== id));
      }
    }
  }

  const toggleSelectBox = () => {
    setIsSearchListOpen(!isSearchListOpen);
  };

  const handleSearchItemClick = (type) => {
    setSelectedSearchType(type);
    setIsSearchListOpen(false);
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const toggleStatusBox = () => {
    setIsStatusListOpen(!isSearchListOpen);
  };

  const handleStatusItemClick = (status) => {
    setSelectedNewStatus(status);
    setIsStatusListOpen(false);
  };

  const openModal = (data) => {
    setSelectedDataSource(data);
    setValidBeginDate(data.validBeginDt);
    setValidEndDate(data.validEndDt);
    setSuspendBeginDate(data.suspBeginDt);
    setSuspendEndDate(data.suspEndDt);

    setIsModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  }

  const closeModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  }

  const handleChangeDate = (setter) => (e) => {
    setter(e.target.value);
  }

  const handleFormat = () => {

  }

  const handleUpload = () => {

  }

  const handleDownload = () => {

  }

  const handleDelete = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      if (window.confirm("삭제하시겠습니까?")) {
        apiWrapper(async () => {
          const { status, data } = await dbmsApi.deleteFireReceiverManage(checkedIds);
          alert(`${data}`)

          //삭제 성공 시 새로고침
          if (status === true) {
            getData(page);
          }
        });
      }
    }
  }

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const { status, data } = await dbmsApi.updateFireReceiverManage(selectedDataSource.id, validBeginDate, validEndDate, suspendBeginDate, suspendEndDate, selectedNewStatus);
        if (status === true) {
          alert(`저장을 완료하였습니다.`);
        } else {
          alert(`저장을 실패하였습니다.\n${data}`)
        }
      });
    }
  }

  const checkValid = () => {
    if (validBeginDate.replace(/-/g, '') > validEndDate.replace(/-/g, '')) {
      alert("사용유효기간 시작일이 종료일보다 클 수 없습니다.");
    } else if (suspendBeginDate.replace(/-/g, '') > suspendEndDate.replace(/-/g, '')) {
      alert("일시정지기간 시작일이 종료일보다 클 수 없습니다.");
    }

    return true;
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard viewTabBoard">
        <div class="top_board pc">
          <p class="title_board">화재수신기 관리</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div className={`select_box ${isSearchListOpen ? "open" : ""}`}>
                <button class="btn_select" onClick={toggleSelectBox}>
                  <p>{getFireReceiverSearchTypeName(selectedSearchType)}</p>
                  <i class="x-icon"></i>
                </button>
                <ul class="list_member">
                  {Object.values(FireReceiverSearchType).map(
                    (item, index) => (
                      <li onClick={() => handleSearchItemClick(item)}>
                        <p>{getFireReceiverSearchTypeName(item)}</p>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <input
                class=""
                type="text"
                placeholder="검색어를 입력해주세요."
                onChange={handleChangeSearchText}
                onKeyDown={handleSearch}
                defaultValue={searchText}
              />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                <img src="/images/my_btn_mb.png" alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">화재수신기 관리</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <ul class="tabs">
          {Object.values(FireReceiverStatus).map(
            (item, index) => (
              <li
                key={item}
                className={`tab-link ${selectedStatus === item ? "current" : ""}`}
                data-tab={item}
                onClick={() => handleTabClick(item)}
              >
                {getFireReceiverStatusName(item)}
              </li>
            )
          )}
        </ul>

        {Object.values(FireReceiverStatus).map(
          (item, index) => (
            <Tab id={item} activeTab={selectedStatus} openModal={openModal} dataSource={dataSource} handleItemClick={handleItemClick} />
          )
        )}

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <button class="item_btn" onClick={handleFormat}>양식</button>
            <button class="item_btn" onClick={handleUpload}>업로드</button>
            <button class="item_btn" onClick={handleDownload}>다운로드</button>
            <button class="item_btn" onClick={handleDelete}>삭제</button>
          </div>

          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {isModalOpen && (
          <div id="modal" class="modal rightModal noticeRightModal FRMrightModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget)
                closeModal();
            }}>
            <form class="modal_content" onSubmit={handleSave}>
              <button type="button" class="close_modal" onClick={closeModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>화재수신기 관리</h2>
              {selectedDataSource && (
                <>
                  <div class="wrap_detail_cont type2">
                    <div class="wrap_detail_item">
                      <p class="title_detail opa-4">일련번호</p>
                      <div class="detail_box">
                        {selectedDataSource.serialNumber}
                      </div>
                    </div>
                    <div class="wrap_detail_item">
                      <p class="title_detail opa-4">DEI</p>
                      <div class="detail_box">
                        {selectedDataSource.dei}
                      </div>
                    </div>
                    <div class="wrap_detail_item">
                      <p class="title_detail opa-4">모델명</p>
                      <div class="detail_box">
                        {selectedDataSource.modelCode}
                      </div>
                    </div>
                    <div class="wrap_detail_item">
                      <p class="title_detail opa-4">최초 통신 일시</p>
                      <div class="detail_box">
                        {getDateTime(new Date(selectedDataSource.initCommDt))}
                      </div>
                    </div>
                    <div class="wrap_detail_item date">
                      <p class="title_detail">사용유효기간</p>
                      <div class="detail_box">
                        <div className={`date-input-wrap ${validBeginDate ? "selected" : ""}`} onChange={handleChangeDate(setValidBeginDate)}>
                          <p class="date-title" style={{ display: validBeginDate ? "none" : "block" }}>{validBeginDate || '년-월-일'}</p>
                          <input type="date" class="form-input" id="start_date" value={validBeginDate} required="required" />
                        </div>
                        <div className={`date-input-wrap ${validEndDate ? "selected" : ""}`} onChange={handleChangeDate(setValidEndDate)}>
                          <p class="date-title" style={{ display: validEndDate ? "none" : "block" }}>{validEndDate || '년-월-일'}</p>
                          <input type="date" class="form-input" id="end_date" value={validEndDate} required="required" />
                        </div>
                      </div>
                    </div>

                    <div class="wrap_detail_item date">
                      <p class="title_detail">일시정지기간</p>
                      <div class="detail_box">
                        <div className={`date-input-wrap ${suspendBeginDate ? "selected" : ""}`} onChange={handleChangeDate(setSuspendBeginDate)}>
                          <p class="date-title" style={{ display: suspendBeginDate ? "none" : "block" }}>{suspendBeginDate || '년-월-일'}</p>
                          <input type="date" class="form-input" id="start_date2" value={suspendBeginDate} required="required" />
                        </div>
                        <div className={`date-input-wrap ${suspendEndDate ? "selected" : ""}`} onChange={handleChangeDate(setSuspendEndDate)}>
                          <p class="date-title" style={{ display: suspendEndDate ? "none" : "block" }}>{suspendEndDate || '년-월-일'}</p>
                          <input type="date" class="form-input" id="end_date2" value={suspendEndDate} required="required" />
                        </div>
                      </div>
                    </div>

                    <div class="wrap_detail_item">
                      <p class="title_detail">상태</p>
                      <div class="detail_box wrap_search">
                        <div className={`select_box ${isStatusListOpen ? "open" : ""}`}>
                          <button class="btn_select" type="button" onClick={toggleStatusBox}>
                            <p>{getFireReceiverStatusChoiceName(selectedNewStatus)}</p>
                            <i class="x-icon"></i>
                          </button>
                          <ul class="list_member">
                            {Object.values(FireReceiverStatusChoice).map(
                              (item, index) => (
                                <li onClick={() => handleStatusItemClick(item)}>
                                  <p>{getFireReceiverStatusChoiceName(item)}</p>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div class="wrap_btn_set">
                <button type="submit" class="btn_dark">저장</button>
              </div>
            </form>
          </div>
        )}
      </div >
    </>
  );
}

const Tab = ({ id, activeTab, openModal, dataSource, handleItemClick }) => {
  return (
    <div className={`tab-content ${activeTab === id ? "current" : ""}`}>
      <div class="table_board ">
        <div class="wrap_table scroll_table">
          <div class="containerTable dbmsTable dbmsTabTable">
            <ul class="head_table">
              <li>
                <p>관리ID</p>
              </li>
              <li>
                <p>화재수신기 일련번호</p>
              </li>
              <li>
                <p>화재수신기 DEI</p>
              </li>
              <li>
                <p>화재수신기 모델코드</p>
              </li>
              <li>
                <p>최초통신일시</p>
              </li>
              <li>
                <p>최종통신일시</p>
              </li>
              <li>
                <p>사용유효기간시작일</p>
              </li>
              <li>
                <p>사용유효기간종료일</p>
              </li>
              <li>
                <p>사용일시정지시작일</p>
              </li>
              <li>
                <p>사용일시정지종료일</p>
              </li>
              <li>
                <p>소방대상물 상태</p>
              </li>
            </ul>

            <div class="body_table">
              <div class="inner_table_wrap">
                {dataSource.results &&
                  dataSource.results.map((item, index) => (
                    <div class="wrap_table_item" onClick={(e) => handleItemClick(e, item.id)}>
                      <div class="inner_table_item table_item_01">
                        <p class="cont_table_item">
                          {item.id}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_02 serial-number_item" onClick={() => openModal(item)}>
                        <p class="cont_table_item">
                          {item.serialNumber}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_03">
                        <p class="cont_table_item">
                          {item.dei}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_04">
                        <p class="cont_table_item">
                          {item.modelCode}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_05">
                        <p class="cont_table_item">
                          {getDateTime(new Date(item.initCommDt))}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_06">
                        <p class="cont_table_item">
                          {getDateTime(new Date(item.lastCommDt))}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_07">
                        <p class="cont_table_item">
                          {item.validBeginDt}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_08">
                        <p class="cont_table_item">
                          {item.validEndDt}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_09">
                        <p class="cont_table_item">
                          {item.suspBeginDt}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_10">
                        <p class="cont_table_item">
                          {item.suspEndDt}
                        </p>
                      </div>
                      <div class="inner_table_item table_item_11">
                        <p class="cont_table_item">
                          {getFireReceiverStatusName(item.status)}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
